import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import DeliveryBoys from "@/pages/DeliveryBoys";
import Collections from "@/pages/Collections";
import CollectionForm from "@/pages/CollectionForm";
import Reports from "@/pages/Reports";
import WeeklyReport from "@/pages/WeeklyReport";
import MinGuaranteeReport from "@/pages/MinGuaranteeReport";
import Branches from "@/pages/Branches";
import Profit from "@/pages/Profit";
import { BranchProvider } from "@/context/BranchContext";

function App() {
  return (
    <div className="App">
      <BranchProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/delivery-boys" element={<DeliveryBoys />} />
              <Route path="/collections" element={<Collections />} />
              <Route path="/collections/new" element={<CollectionForm />} />
              <Route path="/collections/:id" element={<CollectionForm />} />
              <Route path="/weekly" element={<WeeklyReport />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/min-guarantee" element={<MinGuaranteeReport />} />
              <Route path="/profit" element={<Profit />} />
              <Route path="/branches" element={<Branches />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </BranchProvider>
    </div>
  );
}

export default App;
